export type ActivationCodeStatus = 'unused' | 'redeemed' | 'disabled' | 'expired';

export interface ActivationCodeValidation {
  valid: boolean;
  reason?: string;
  status?: ActivationCodeStatus;
  source?: string;
  campaignId?: string | null;
  expiresAt?: string | null;
  codeId?: string;
}

export const normalizeActivationCodeInput = (code: string): string => {
  return (code || '').toString().replace(/[^A-Za-z0-9]/g, '').toUpperCase();
};

export const evaluateActivationCodeEligibility = (
  status: ActivationCodeStatus,
  expiresAt?: string | Date | null,
  now: Date = new Date()
): { valid: boolean; reason?: string } => {
  const expiryDate = expiresAt ? new Date(expiresAt) : null;
  const isExpiredStatus = status === 'expired' || (!!expiryDate && expiryDate.getTime() < now.getTime());
  if (isExpiredStatus) {
    return { valid: false, reason: 'expired' };
  }

  if (status === 'disabled') {
    return { valid: false, reason: 'disabled' };
  }

  if (status === 'redeemed') {
    return { valid: false, reason: 'already_redeemed' };
  }

  return { valid: true };
};

